import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div``

export const LoadingStyle = styled.div<{ constrast: boolean }>`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  div {
    width: 0.8rem;
    height: 0.8rem;
    margin: 2rem 0.3rem;
    background: ${({ constrast }) =>
      constrast ? colors.white : colors.primaryText};
    border-radius: 50%;
    animation: 0.9s bounce infinite alternate;

    &:nth-child(2) {
      animation-delay: 0.3s;
    }

    &:nth-child(3) {
      animation-delay: 0.6s;
    }
  }
  @keyframes bounce {
    to {
      opacity: 0.6;
      transform: translate3d(0, -1rem, 0);
    }
  }
`
